import React, { useMemo, memo } from "react";
import TaskItem from "./TaskItem";

const PropertyGroup = memo(function PropertyGroup({
  propertyName,
  tasks,
  propertyNameToIdMap,
  propertyKeyMap,
  handleTaskClick,
  handleToggle,
  isWeekly = false,
}) {
  // Memoize display name calculation (only recalculates when propertyName, propertyNameToIdMap, or propertyKeyMap changes)
  const displayName = useMemo(() => {
    const propId = propertyNameToIdMap[propertyName];
    const keyValue = propId ? (propertyKeyMap[propId] || propertyKeyMap[String(propId)]) : null;
    return keyValue ? `${propertyName} (${keyValue})` : propertyName;
  }, [propertyName, propertyNameToIdMap, propertyKeyMap]);

  if (isWeekly) {
    return (
      <div
        style={{
          marginBottom: 8,
        }}
      >
        <h3
          style={{
            margin: 0,
            marginBottom: 8,
            fontSize: 13,
            fontWeight: 600,
            color: "#676879",
          }}
        >
          {displayName}
        </h3>
        <ul
          style={{
            listStyle: "none",
            padding: 0,
            margin: 0,
          }}
        >
          {tasks.map((task) => (
            <TaskItem
              key={`${task.id}-${task.isCompletedEntry ? 'completed' : 'due'}`}
              task={task}
              propertyName={propertyName}
              handleTaskClick={handleTaskClick}
              handleToggle={handleToggle}
              isWeekly={true}
            />
          ))}
        </ul>
      </div>
    );
  }

  return (
    <div
      style={{
        borderRadius: 8,
        border: "1px solid #e6e9ef",
        padding: 16,
        marginBottom: 12,
        background: "#ffffff",
      }}
    >
      <h2
        style={{
          margin: 0,
          marginBottom: 8,
          fontSize: 16,
          fontWeight: 600,
        }}
      >
        {displayName}
      </h2>

      <ul
        style={{
          listStyle: "none",
          padding: 0,
          margin: 0,
        }}
      >
        {tasks.map((task) => (
          <TaskItem
            key={`${task.id}-${task.isCompletedEntry ? 'completed' : 'due'}`}
            task={task}
            propertyName={propertyName}
            handleTaskClick={handleTaskClick}
            handleToggle={handleToggle}
            isWeekly={false}
          />
        ))}
      </ul>
    </div>
  );
});

export default PropertyGroup;

